<template>
    <div>
      <loading v-model:active="myprogress"
               :can-cancel="false"
               :is-full-page="true"
      ></loading>


        <Transition name="fade">
            <div
                    class="snackbar snackbar-success"
                    v-if="snackbar2"
            >
                <div class="snackbar-content" v-html="msg">
                </div>
            </div>
        </Transition>

        <Transition name="fade">
            <div
                    class="snackbar snackbar-warning"
                    v-if="snackbar_warning"
            >
                <div class="snackbar-content" v-html="msg">
                </div>
            </div>
        </Transition>


        <Transition name="fade">
            <div
                    class="snackbar snackbar-error snackbar-bottom"
                    v-if="snackbar"
            >
                <div class="snackbar-content" v-html="msg">
                </div>
            </div>
        </Transition>


        <Transition name="fade">
            <div
                    class="snackbar snackbar-error snackbar-top"
                    v-if="snackbar_up"
            >
                <div class="snackbar-content" v-html="msg">
                </div>
            </div>
        </Transition>


        <!-- dlg//-->
        <BaseDialog
            :modelValue="dlg"
            @update:modelValue="dlg = $event"
            max-width="600px"
        >
            <div class="dialog-card">
                <div class="dialog-title" v-html="mtitle"></div>
                <div class="dialog-content content_css" v-html="mcontent">
                </div>

                <div class="dialog-actions">
                    <span class="spacer"></span>
                    <button
                            class="btn-text btn-success"
                            @click="dlg=false"
                    >
                        확인
                    </button>
                </div>
            </div>
        </BaseDialog>


        <BaseDialog
            :modelValue="mprompt"
            @update:modelValue="mprompt = $event"
            max-width="600px"
        >
            <div class="dialog-card">
                <div class="dialog-title">{{ mtitle }}</div>
                <div
                    class="dialog-content content_css"
                    v-html="mcontent">
                </div>
                <div class="dialog-input-area">
                    <my-input
                        focus
                        v-model="minput"
                        :label="mlabel"
                        clearable
                        @keyenter="promptok()"
                    />
                </div>

              <div v-if="keyboard" class="prompt-keyboard">
              </div>
              <!-- 계산금액//-->
              <SimpleKeyboard
                  v-if="keyboard"
                  style="margin-top: 15px;"
                  :keyboardClass="'prompt-keyboard'"
                  :init="minput"
                  :phone="true"
                  @onChange="onChange" @onKeyPress="onKeyPress" />


              <div class="dialog-actions">

                    <my-button
                        style="flex:1"
                        variant='secondary'
                        size="medium"
                        name="취소"
                        @click="mprompt = false"
                    />


                    <my-button
                        style="flex:1;margin-left: 10px"
                        variant='primary'
                        size="medium"
                        name="확인"
                        @click="promptok()"
                    />

                </div>
            </div>

        </BaseDialog>

        <BaseDialog
            :modelValue="mconfirm"
            @update:modelValue="mconfirm = $event"
            max-width="600px"
            :overlay-style="{ zIndex: 1200 }"
            @keyup.enter="confirmok()"
        >
            <div class="dialog-card">
                <div class="dialog-title">{{ mtitle }}</div>
                <div class="dialog-content content_css" v-html="mcontent">
                </div>

                <div class="dialog-actions">

                        <my-button
                            style="flex:1"
                            variant='secondary'
                            size="medium"
                            name="아니오"
                            @click="mconfirm = false"
                        />


                    <my-button
                        style="flex:1;margin-left: 10px"
                        variant='primary'
                        size="medium"
                        name="예"
                        @click="confirmok()"
                    />

                </div>
            </div>
        </BaseDialog>


    </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

import MyButton from "@/components/form/MyButton2.vue";
import MyInput from "@/components/form/MyInput.vue"
import SimpleKeyboard from "@/components/common/SimpleKeyboardNum.vue"
import BaseDialog from "@/components/ui/BaseDialog.vue"
export default {
    data: () => ({
        keyboard:false,
        err_tm: null,
        dlg: false,

        minput: '',
        mlabel: '',

        mprompt: false,

        mconfirm: false,

        myprogress: false,
        snackbar: false,
        snackbar_up: false,
        snackbar2: false,
        snackbar_warning: false,
        msg: '',

        mtitle: '',
        mcontent: '',
        mcallback: null
    }),
    components: {
        MyInput,
        MyButton,
      SimpleKeyboard,
      Loading,
      BaseDialog
    },
    created() {
    },
    destroyed() {
    },
    mounted() {

        this.$eventBus.$on('loading', this.loading)
        this.$eventBus.$on('alert', this.alert)
        this.$eventBus.$on('info', this.info)
        this.$eventBus.$on('warning', this.warning)
        this.$eventBus.$on('dlg', this.showdlg)

        this.$eventBus.$on('confirm', this.confirm)
        this.$eventBus.$on('prompt', this.prompt)
    },
    methods: {
      onChange(input) {
        console.log(input)
        this.minput = input
      },
      onKeyPress() {
      },
      onKeyPressEvt: function (evt) {
            if (evt.keyCode === 13) {
                if (this.mconfirm) {
                    this.confirmok()
                }
            }
        },
        promptok: function () {

            this.mprompt = false
            if (this.mcallback != null)
                this.mcallback(this.minput.trim())

            this.minput = ''
        },
        //prompt: function (t, m, lb, callback) {
        prompt: function (a, t, m, lb, callback) {

            var t = a['title']
            var m = a['content']
            var lb = a['label']
            var callback = a['callback']

            if(a['keyboard']) {
              this.keyboard = true
            } else {
              this.keyboard = false
            }


            this.mcallback = null

            var tmpInput = a['tmp']
            if(tmpInput) {
                this.minput = tmpInput
            }


            this.mlabel = lb
            this.mtitle = t
            this.mcontent = m
            this.mprompt = true
            /*
            var v = this
            this.$nextTick(() => {

                setTimeout(function () {
                    try {
                        v.$refs.inp.focus()
                    } catch (e) {
                    }
                }, 500)
            })
            */

            this.mcallback = callback
        },

        showdlg: function (title, msg) {
            this.dlg = true
            this.mtitle = title
            this.mcontent = msg
        },

        confirmok: function () {
            this.mconfirm = false
            if (this.mcallback != null)
                this.mcallback()
        },
        //confirm:function(t,m, callback) {
        confirm: function (a) {
            var t = a['title']
            var m = a['content']
            var callback = a['callback']

            this.mcallback = null

            this.mtitle = t
            this.mcontent = m
            this.mconfirm = true

            this.mcallback = callback
        },
        loading: function (b) {
            this.myprogress = b
        },
        alert: function (msg, up) {

            this.msg = msg

            if (!!up)
                this.snackbar_up = true
            else
                this.snackbar = true

            if (this.err_tm) {
                try {
                    clearTimeout(this.err_tm)
                    this.err_tm = null
                } catch (e) {
                }
            }

            var that = this
            this.err_tm = setTimeout(function () {
                that.snackbar_up = false
                that.snackbar = false
                that.err_tm = null
            }, 2000)

        },
        info: function (msg) {
            this.msg = msg
            this.snackbar2 = true

            var that = this
            setTimeout(function () {
                that.snackbar2 = false

            }, 2000)
        },
        warning: function (msg) {
            this.msg = msg
            this.snackbar_warning = true

            var that = this
            setTimeout(function () {
                that.snackbar_warning = false
            }, 2000)
        }

    }
}
</script>
<style scoped>
.content_css {
    color: #777;
}

/* Snackbar styles */
.snackbar {
    display: flex;
    place-content: center;
    align-items: center;
    z-index: 99999999;
    left: 0;
    width: 100%;
    min-height: 50px;
    position: fixed;
    color: #fff;
}

.snackbar-bottom {
    bottom: 0;
}

.snackbar-top {
    top: 0;
}

.snackbar-success {
    background-color: #2E7D32;
    bottom: 0;
}

.snackbar-error {
    background-color: #E64A19;
}

.snackbar-warning {
    background-color: #F57C00;
    bottom: 0;
}

.snackbar-content {
    font-size: 1.0em;
    margin: 10px;
}

/* Fade transition */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

/* Dialog styles */
.dialog-card {
    background: white;
    border-radius: 14px;
    padding: 16px;
}

.dialog-title {
    font-size: 15px;
    font-weight: 600;
    color: #1f2937;
    margin: 0 0 6px;
    padding: 0;
}

.dialog-content {
    font-size: 13px;
    color: #6b7280;
    line-height: 1.5;
    padding: 0;
    margin-bottom: 14px;
}

.dialog-input-area {
    padding: 0;
    margin-bottom: 14px;
}

.dialog-actions {
    display: flex;
    padding: 0;
    gap: 8px;
}

.spacer {
    flex: 1;
}

.btn-text {
    background: transparent;
    border: 1px solid #e2e8f0;
    padding: 8px 16px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    border-radius: 8px;
    transition: background-color 0.2s;
}

.btn-text:hover {
    background-color: rgba(0, 0, 0, 0.05);
}

.btn-success {
    color: #4F46E5;
}

</style>
